// This icon file is generated automatically.
var PPushpinStopOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 17 11", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M16.5 9.05c0 .76-.62 1.37-1.37 1.37h-1.75c-.76 0-1.38-.61-1.38-1.37v-.38H8.79l-1.96 1.66c-.44.37-1.07.34-1.48-.04l-.09-.1C5.1 10 5 9.75 5 9.49V6.21H.66a.66.66 0 010-1.32H5V1.62c0-.57.43-1.05 1-1.1L6.1.5c.27 0 .52.09.72.26l2.01 1.7H12v-.42c0-.71.55-1.3 1.24-1.37H15.13c.75 0 1.37.61 1.37 1.37zm-1 0v-7c0-.2-.17-.37-.37-.37h-1.75c-.21 0-.38.16-.38.37v1.42H8.48l-2.3-1.94a.11.11 0 00-.18.09v7.86a.11.11 0 00.19.09l2.23-1.9H13v1.38c0 .2.17.38.38.38h1.75c.2 0 .37-.17.37-.38z", "fill-rule": "nonzero" } }] }, "name": "p-pushpin-stop", "theme": "outlined" };
export default PPushpinStopOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PPushpinStopOutlined.js
// module id = 3565
// module chunks = 0